const MODIFIERS = [
  ['ctrlKey', 'Ctrl'],
  ['altKey', 'Alt'],
  ['shiftKey', 'Shift'],
] as const;

export const isModifier = (code: string): boolean =>
  /^(Shift|Control|Alt|Meta)(Left|Right)$/.test(code);

/** A key with the modifiers held, as `Ctrl+Alt+Shift+KeyF`; a modifier on its own is just its code. Cmd is left out: macOS drops other keys' keyups while it's down. */
export function chord(
  e: Pick<KeyboardEvent, 'code' | 'ctrlKey' | 'altKey' | 'shiftKey'>,
): string {
  if (isModifier(e.code)) return e.code;
  const held = MODIFIERS.filter(([flag]) => e[flag]).map(([, name]) => name);
  return [...held, e.code].join('+');
}
